import { Flex, Typography } from "djuno-design";
import {
  useDjunoDesignPageUrl,
  useShowPageUrl,
  useWindowOnClickPageUrl,
} from "../../urls";
import { ComponentCard } from "../ComponentsOverviewPage";

const { Title, Text } = Typography;
const HooksOverviewPage = () => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Flex direction="col">
        <Flex direction="col">
          <Title level={4}>Hooks Overview</Title>
          <Text size="sm" style={{ marginBottom: 30 }}>
            djuno-design (dd) provides plenty of react hook to enrich your web
            applications, and we will improve components experience
            consistently.
          </Text>
        </Flex>
      </Flex>
      <div className="flex flex-wrap gap-4">
        <ComponentCard to={useDjunoDesignPageUrl}>
          <Title level={3}>{`useDjunoDesign`}</Title>
        </ComponentCard>
        <ComponentCard to={useShowPageUrl}>
          <Title level={3}>{`useShow`}</Title>
        </ComponentCard>
        <ComponentCard to={useWindowOnClickPageUrl}>
          <Title level={3}>{`useWindowOnClick`}</Title>
        </ComponentCard>
      </div>
    </div>
  );
};

export default HooksOverviewPage;
